import { supabase } from "@/integrations/supabase/client";

export type LogType =
  | "LOGIN"
  | "LOGOUT"
  | "DEVICE_APPROVAL"
  | "MESSAGE_SEND"
  | "ENCRYPT_ERROR"
  | "DECRYPT_ERROR"
  | "SLOW_OPERATION"
  | "ERROR"
  | "SESSION_ROTATE"
  | "PAYMENT_SEND";

const SLOW_THRESHOLD_MS = 2000;

/**
 * Log an event to the app_logs table (fire-and-forget).
 * Only logs in production or when explicitly called.
 */
export async function logEvent(
  type: LogType,
  message: string,
  metadata: Record<string, unknown> = {}
) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await (supabase as any).from("app_logs").insert({
      type,
      message,
      metadata,
      user_id: user?.id ?? null,
    });
  } catch {
    // Never let logging break the app
  }
}

/**
 * Measure an async operation and log if it exceeds the slow threshold.
 */
export async function trackPerformance<T>(
  label: string,
  fn: () => Promise<T>
): Promise<T> {
  const start = performance.now();
  const result = await fn();
  const elapsed = performance.now() - start;

  if (elapsed > SLOW_THRESHOLD_MS) {
    logEvent("SLOW_OPERATION", `${label} took ${Math.round(elapsed)}ms`, {
      label,
      elapsed_ms: Math.round(elapsed),
    });
  }

  return result;
}
